
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'CommonButtonMore',
  emits: ['click'],
  props: {
    size: {
      type: String as PropType<'sm' | 'md' | 'xl'>,
      require: false,
      default: 'md',
    },
  },
  methods: {
    click(e: any) {
      this.$emit('click', e);
    },
  },
});
